export interface StepDotsProps {
  count: number;
  /** Zero-based active index. */
  active: number;
  /** Accessible name, e.g. t('ec2.tour.step', {current, total}). */
  label?: string;
  className?: string;
}

/** Step beats — 8px dots, active in --primary. Shared by the quiz player and the tour. */
export function StepDots({ count, active, label, className = '' }: StepDotsProps) {
  return (
    <div
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-testid="ec-step-dots"
      className={`flex items-center gap-2 ${className}`}
    >
      {Array.from({ length: count }, (_, i) => (
        <span
          key={i}
          aria-hidden
          className={`size-2 rounded-full transition-colors duration-(--duration-base) ${i === active ? 'bg-primary' : 'bg-fg-muted/40'}`}
        />
      ))}
    </div>
  );
}
